/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  BefConfigContext,
  BefGlobalContext,
  BefLanguageServiceContext,
  BefPage,
  BefPageControllerContext,
  BefUserServiceContext,
} from '@beflam/bef-core';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.scss';
import {
  ContactsOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { createComponentPage } from '../lib/renderSchemaHelper';
declare var $: any;

export function Header(props: any) {
  const sGlobal = useContext(BefGlobalContext);
  const navigate = useNavigate();
  const befLanguageService = useContext(BefLanguageServiceContext);
  const userService = useContext(BefUserServiceContext);
  const pageController = useContext(BefPageControllerContext);
  const sConfig = useContext(BefConfigContext);
  // const [UserAvatar, setUserAvatar] = useState<string>(sGlobal.userAvatar);
  // const [chatDatas, setChatDatas] = useState<any[]>([{}]);
  const [isReady, setIsReady] = useState<boolean>(false);
  let customHeadBtns: any[] = []; //自定义头部按钮
  const [userMenuVisible, setUserMenuVisible] = useState<boolean>(false); //用户和部门菜单显示权限
  const If = (props: { condition: boolean; then: any; else: any }) => {
    const condition = props.condition || false;
    const positive = props.then || null;
    const negative = props.else || null;

    return condition ? positive : negative;
  };

  const exit = () => {
    userService.logout();
    navigate('/login');
  };

  const openNativePage = (componentName: string, title: string, props?: any) => {
    sGlobal.aiVisibleEvent.emit({ visible: false, type: '' });
    let page = createComponentPage(componentName, props);
    pageController.show(page, title);
  };
  const showUserSetting = () => {
    let _props = {
      rpcAssembly: 'Beflam.Framework',
      rpcModule:
        'Beflam.Framework.Service.UserService',
      id: sGlobal.session.userId,
      isUser: true,
      style: {
        flex: '1',
        width: '100%',
      },
    };
    openNativePage('BefEditUser', "用户编辑", _props);
  };
  const openUserList = () => {
    openNativePage('BefUserList', "用户管理");
  };
  const openDepList = () => {
    openNativePage('BefDepList', "部门管理");
  };
  useEffect(() => {
    // 菜单切换
    $('.navbar-minimalize').click(function () {
      $('body').toggleClass('mini-navbar');
    });

    const initEventSub = props.initEvent.subscribe(async (result: any) => {
      // setUserAvatar(result.USERAVATAR);
      if (
        result &&
        result.Permission &&
        result.Permission.BEF_SYS_ADMIN &&
        result.Permission.BEF_SYS_ADMIN.includes('User')
      ) {
        setUserMenuVisible(true);
      } else {
        setUserMenuVisible(false);
      }
      setIsReady(true);
    });
    return () => {
      initEventSub.unsubscribe();
    };
  }, []);


  const quiteImpersonate = () => {
    userService.quiteImpersonate();
    window.location.reload();
  }

  return (
    <div style={{ width: '100%' }}>
      <nav
        className="navbar navbar-fixed-top bef-navbar-static-top"
        role="navigation"
        style={{ marginBottom: 0 }}
      >
        <div
          className="nav-header navbar-left my-nav-header bef-nav-header"
          style={{ overflow: 'hidden' }}
        >
          <img
            alt="image"
            className="my-admin-icon my-admin-icon-normal"
            src="./assets/img/icon_beflamNext.png"
          />
          <img
            alt="image"
            className="my-admin-icon my-admin-icon-small"
            src="./assets/img/icon_beflamNext_mini.png"
          />
          <a className="navbar-minimalize">
            <i>
              <svg
                viewBox="0 0 1024 1024"
                width="1em"
                height="1em"
                fill="currentColor"
              >
                <path d="M426.666667 469.333333a42.666667 42.666667 0 1 0 0 85.333334v-85.333334z m426.666666 85.333334a42.666667 42.666667 0 1 0 0-85.333334v85.333334z m-426.666666 0h426.666666v-85.333334H426.666667v85.333334z"></path>
                <path d="M456.832 481.834667a42.666667 42.666667 0 0 0-60.330667 60.330666l60.330667-60.330666z m110.336 230.997333a42.666667 42.666667 0 0 0 60.330667-60.330667l-60.330667 60.330667z m-170.666667-170.666667l170.666667 170.666667 60.330667-60.330667-170.666667-170.666666-60.330667 60.330666z"></path>
                <path d="M396.501333 481.834667a42.666667 42.666667 0 0 0 60.330667 60.330666l-60.330667-60.330666z m230.997334-110.336a42.666667 42.666667 0 0 0-60.330667-60.330667l60.330667 60.330667z m-170.666667 170.666666l170.666667-170.666666-60.330667-60.330667-170.666667 170.666667 60.330667 60.330666zM213.333333 170.666667a42.666667 42.666667 0 0 0-85.333333 0h85.333333zM128 853.333333a42.666667 42.666667 0 1 0 85.333333 0H128zM128 170.666667v682.666666h85.333333V170.666667H128z"></path>
              </svg>
            </i>
          </a>
        </div>
        {isReady && (
          <div className="nav navbar-top-links navbar-right navbar-right-all">
            <ul>
              <li style={{
                border: '1px solid #E8E8E8',
                borderRadius: '5px',
                boxShadow: ' 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922)'
              }}>
                <a style={{ width: 36, backgroundColor: '#ffffff', color: '#3e4265', border: 0}}
                  onClick={() => {
                    const currentUrl = window.location.href;
                    window.open(currentUrl, '_blank');
                  }}>
                  <i className="fa fa-clone"  style={{fontWeight:'bolder'}} />
                </a>
              </li>
              {customHeadBtns?.map((item) => {
                return (
                  <li className="hidden-xs" style={{ marginRight: '0px' }}>
                    <a
                      className={'bef-custombtn-' + item.ClassName}
                      href={item.Url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className={item.Icon} />
                      {item.Text}
                    </a>
                  </li>
                );
              })}
              {/* <li className="hidden-xs">
              <a className="dropdown" data-toggle="dropdown" style={{ width: 36, backgroundColor: '#f6f6f6', color: '#3e4265', border: 0 }}>
                <i className="fa fa-bell-o" /><span className="bef-chat-badge">{chatDatas.length}</span>
              </a>
              <div role="menu" className="dropdown-menu dropdown-menu-right bef-notification-dropdown">
                <div className="bef-topnav-dropdown-header">
                  <h4 className="bef-notification-title">Notifications</h4>
                </div>
                <div className="bef-noti-content">
                  <ul className="bef-notification-list">
                    {chatDatas.slice(0, 3).map((item, index) =>
                    (<li key={`chat${index}`}>
                      <a>
                        <div style={{ display: 'flex' }}>
                          <span style={{ width: '36px', height: '36px', margin: '0 16px 0 0', borderRadius: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <img style={{ width: '100%', height: '100%', borderRadius: '5px' }} src="https://crms.dreamstechnologies.com/html/template/assets/img/profiles/avatar-03.jpg" alt="Profile" />
                          </span>
                          <div style={{ flexGrow: 1 }}>
                            <p className="bef-noti-details">Denise Nedry replied to Anna Srzand</p>
                            <p className="bef-noti-sub-details">“Oh, I finished de-bugging the phones, but the system's compiling for eighteen minutes, or twenty.  So, some minor systems may go on and off for a while.”</p>
                            <p style={{ fontSize: '12px', color: '#262a2a', margin: 0 }}>Last Wednesday at 9:42 am</p>
                          </div>
                        </div>
                      </a>
                    </li>))}
                  </ul>
                </div>
                <div className="bef-topnav-dropdown-footer">
                  <a className="bef-view-link">View all</a>
                  <a className="bef-clear-link">Clear all</a>
                </div>
              </div>
            </li> */}
              {/* <li className="hidden-xs">
                <a className="bef-ai" title="AI" style={{ width: 36, backgroundColor: '#f6f6f6', color: '#3e4265' }} onClick={openAIDialog}>
                  <i>
                    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
                      <path d="M269.69088 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464s68.46464-30.64832 68.46464-68.46464c0-37.80608-30.65856-68.46464-68.46464-68.46464s-68.46464 30.65856-68.46464 68.46464zM899.54304 1.21856H123.63776c-20.19328 0-36.51584 16.32256-36.51584 36.51584v753.09056c0 20.19328 16.32256 36.5056 36.51584 36.5056h775.90528c20.19328 0 36.5056-16.31232 36.5056-36.5056V37.7344c0.01024-20.19328-16.30208-36.51584-36.5056-36.51584zM863.0272 754.30912H160.14336V74.25024H863.0272v680.05888zM616.56064 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464 37.81632 0 68.46464-30.64832 68.46464-68.46464 0-37.80608-30.64832-68.46464-68.46464-68.46464-37.80608 0-68.46464 30.65856-68.46464 68.46464z m285.4912 634.4192H121.12896c-18.82112 0-34.00704 16.32256-34.00704 36.51584v41.07264c0 5.02784 3.76832 9.13408 8.448 9.13408h831.92832c4.67968 0 8.448-4.10624 8.448-9.13408v-41.07264c0.11264-20.20352-15.06304-36.51584-33.8944-36.51584zM685.02528 507.84256H338.15552c-5.0176 0-9.12384 4.10624-9.12384 9.13408v68.46464c0 5.0176 4.10624 9.12384 9.12384 9.12384h346.88c5.0176 0 9.13408-4.10624 9.13408-9.12384v-68.46464c-0.01024-5.02784-4.11648-9.13408-9.14432-9.13408z m0 0" />
                    </svg>
                  </i>
                </a>
              </li> */}

              {sGlobal.session.personateSession && (
                <li className="hidden-xs">
                  <a
                    className="dropdown-item"
                    onClick={quiteImpersonate}
                    style={{
                      width: 'auto',
                      padding: '8px 12px',
                      cursor: 'pointer',
                      backgroundColor: '#ff9800',
                      color: '#fff',
                      borderRadius: '4px',
                      marginRight: '10px',
                    }}
                  >
                    退出模拟[{sGlobal.session.personateSession.userName}模拟{sGlobal.session.userName}]
                  </a>
                </li>
              )}

              {userMenuVisible && (
                <li className="hidden-xs">
                  <a
                    className="dropdown"
                    data-toggle="dropdown"
                    style={{
                      width: 36,
                      fontSize: '20px',
                      backgroundColor: 'transparent',
                      color: '#3e4265',
                    }}
                  >
                    <i>
                      <UsergroupAddOutlined />
                    </i>
                  </a>
                  <div
                    role="menu"
                    className="dropdown-menu dropdown-menu-right"
                  >
                    <a className="dropdown-item" onClick={openUserList}>
                      <TeamOutlined
                        style={{
                          fontSize: '16px',
                          margin: 0,
                          marginRight: '8px',
                        }}
                      />
                      用户管理
                    </a>
                    <a className="dropdown-item" onClick={openDepList}>
                      <SolutionOutlined
                        style={{
                          fontSize: '16px',
                          margin: 0,
                          marginRight: '8px',
                        }}
                      />
                      部门管理
                    </a>
                  </div>
                </li>
              )}

              <li className="hidden-xs">
                <a
                  className="dropdown"
                  data-toggle="dropdown"
                  style={{ width: 36, backgroundColor: 'transparent' }}
                >
                  <If
                    condition={!sGlobal.userAvatar}
                    then={<img src="./assets/img/avatar1.png" alt="Profile" />}
                    else={
                      <img
                        src={`${sGlobal.config.host}/${sGlobal.userAvatar}`}
                        alt="Profile"
                      />
                    }
                  />
                </a>
                <div role="menu" className="dropdown-menu dropdown-menu-right">
                  <a className="dropdown-item" onClick={showUserSetting}>
                    <i className="fa fa-user-o"></i>My Profile
                  </a>
                  <a className="dropdown-item" onClick={exit}>
                    <i className="fa fa-sign-out" />
                    {sGlobal.session.lang
                      ? befLanguageService.getLanguage('framework', 'Logout')
                      : 'Logout'}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        )
        }
      </nav >
    </div >
  );
}
